import React from "react";
import {DertigenEvent} from "../../model/DertigenEvent";

export const getDisplayedStripes = (move: DertigenEvent): number => {
    if (move.drinkingMove || move.turnMove === false) {
        return move.stripes ?? 0;
    }

    return move.effectiveStripes ?? move.stripes ?? 0;
};

export const getFutureDoublerLabel = (count: number): string => {
    return count === 1
        ? `${count}× beurtverdubbelaar`
        : `${count}× beurtverdubbelaars`;
};

interface FutureDoublerMoveBadgeProps {
    move: DertigenEvent;
}

const FutureDoublerMoveBadge: React.FC<FutureDoublerMoveBadgeProps> = ({move}) => {
    const count = move.futureDoublerCount ?? 0;

    if (count < 1 || move.turnMove !== true || move.drinkingMove) {
        return null;
    }

    return <span className="future-doubler-move-badge">{getFutureDoublerLabel(count)}</span>;
};

export default FutureDoublerMoveBadge;
